import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slidesContainer", "indicator", "video", "subtitle"];

  connect() {
    this.currentSlide = 0;
    this.totalSlides = 5;
    this.userInteracted = false;
    this.hasAutoSlided = false;
    this.setupIntersectionObserver();
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupIntersectionObserver() {
    // Create observer to detect when slider is visible
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            !this.hasAutoSlided &&
            !this.userInteracted
          ) {
            // Slider is visible and hasn't auto-slided yet
            this.hasAutoSlided = true;

            // Wait 1 second then slide to next (as a visual cue)
            setTimeout(() => {
              if (!this.userInteracted) {
                this.nextSlide();
              }
            }, 1000);
          }
        });
      },
      {
        threshold: 1, // Trigger when 100% of the slider is visible
      }
    );

    // Start observing the slider element
    this.observer.observe(this.element);
  }

  nextSlide(event) {
    // If called via user interaction, mark it
    if (event) {
      this.userInteracted = true;
    }

    this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    this.updateSlider();
  }

  previousSlide() {
    // User manually navigated
    this.userInteracted = true;

    this.currentSlide =
      (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    this.updateSlider();
  }

  goToSlide(event) {
    // User manually selected a slide
    this.userInteracted = true;

    this.currentSlide = parseInt(
      event.currentTarget.dataset.appSliderSlideIndex
    );
    this.updateSlider();
  }

  updateSlider() {
    // Update slide position
    const offset = -this.currentSlide * 100;
    this.slidesContainerTarget.style.transform = `translateX(${offset}%)`;

    // Update indicators
    this.indicatorTargets.forEach((indicator, index) => {
      if (index === this.currentSlide) {
        indicator.classList.remove("bg-gray-400", "w-2");
        indicator.classList.add("bg-black", "w-8");
      } else {
        indicator.classList.remove("bg-black", "w-8");
        indicator.classList.add("bg-gray-400", "w-2");
      }
    });

    // Restart videos when slide becomes active
    this.videoTargets.forEach((video, index) => {
      if (index === this.currentSlide) {
        video.currentTime = 0;
        video.play();
      } else {
        video.pause();
      }
    });

    // Update subtitle visibility
    this.subtitleTargets.forEach((subtitle) => {
      const subtitleIndex = parseInt(
        subtitle.dataset.appSliderSubtitleIndex
      );

      if (subtitleIndex === this.currentSlide) {
        subtitle.classList.remove("hidden");
        subtitle.classList.add("block");
      } else {
        subtitle.classList.remove("block");
        subtitle.classList.add("hidden");
      }
    });
  }
}
